import { FunctionComponent, useRef, useState } from 'react';
import classnames from 'classnames';

import CloseIcon from 'theme/icons/x.svg';

import Slick from 'components/layout/Slick';

import Title from '../Title';

import { Props } from './index';
import StyledComponent from './styles';

const PublicPageJobSectionJobBlocksJobHeader: FunctionComponent<Props> = ({
    images,
    title,
}) => {
    const previewRef = useRef(null);
    const sliderRef = useRef(null);
    const [slideIndex, SetSlideIndex] : [number, Function] = useState(0);
    const [previewVisibility, SetPreviewVisibility]: [boolean, Function] = useState(false);
    const imagesToShow = images.length >= 3 ? 3 : images.length;

    const settings = {
        arrows: true,
        dots: false,
        slidesToShow: imagesToShow,
        slidesToScroll: 1,
        fade: false,
        infinite: true,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    centerMode: true,
                    slidesToShow: 1,
                },
            },
        ],
        beforeChange: (index, nextIndex)=> SetSlideIndex(nextIndex),
    };
    const previewSettings = {
        arrows: true,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: false,
        infinite: true,
        initialSlide: slideIndex,
        afterChange: index=> {if(sliderRef?.current?.slickGoTo) sliderRef.current.slickGoTo(index);},
    };
    const handleElClick = () => {
        SetPreviewVisibility(true);
    };
    const handleClose = () => {
        SetPreviewVisibility(false);
    };
    return (
        <StyledComponent className="public-page-company-site-section-company-block-gallery">
            <Title title={title} />
            { imagesToShow > 1
                ? (
                    <>

                        <div className={classnames(
                            'slick-container',
                            { 'hide-arrows' : previewVisibility }
                        )}
                        >
                            <Slick
                                reference={sliderRef}
                                sliderProps={settings}
                            >
                                {Array.isArray(images) && images.map(({ id, file }) => (
                                    <div
                                        key={id}
                                        className="gallery-container"
                                        onClick={()=>handleElClick()}
                                    >
                                        <img
                                            className="gallery-image"
                                            src={file?.imageUrl}
                                            alt=""
                                            loading="lazy"
                                        />
                                    </div>
                                ))}
                            </Slick>
                        </div>
                        {previewVisibility && (
                            <div
                                className="slick-container preview"
                            >
                                <button
                                    className="preview__close"
                                    onClick={()=>handleClose()}
                                >
                                    <img
                                        src={CloseIcon}
                                        alt="Zamknij"
                                        title='Zamknij'
                                        className='preview__close-img'
                                    />
                                </button>
                                <Slick
                                    reference={previewRef}
                                    sliderProps={previewSettings}
                                >
                                    {Array.isArray(images) && images.map(({ id, file }) => (
                                        <div
                                            key={id}
                                            className="preview__container"
                                        >
                                            <img
                                                className="preview__image"
                                                src={file?.imageUrl}
                                                alt=""
                                                loading="lazy"
                                            />
                                        </div>
                                    ))}
                                </Slick>
                            </div>
                        )}
                    </>
                )
                : Array.isArray(images) && (
                    <div
                        key={images[0]?.id}
                        className="gallery-container-single"
                    >
                        <img
                            className="gallery-image"
                            src={images[0]?.file?.imageUrl}
                            alt=""
                            loading="lazy"
                        />
                    </div>
                )
            }
        </StyledComponent>
    );
};

export default PublicPageJobSectionJobBlocksJobHeader;
